import { Marketday } from './';
import {JsonProperty} from 'json-typescript-mapper';

export class Boothfee {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  @JsonProperty('validFrom')
  public validFrom?: string;

  @JsonProperty('validMonth')
  public validMonth?: number;

  @JsonProperty('priceType')
  public priceType?: string;

  @JsonProperty('priceCategoryA')
  public priceCategoryA?: number;

  @JsonProperty('priceCategoryB')
  public priceCategoryB?: number;

  @JsonProperty('priceCategoryC')
  public priceCategoryC?: number;

  @JsonProperty('priceCategoryD')
  public priceCategoryD?: number;

  @JsonProperty('minBoothFee')
  public minBoothFee?: number;

  @JsonProperty('permanentMarketingFee')
  public permanentMarketingFee?: number;

  @JsonProperty('basicCharges')
  public basicCharges?: number;

  @JsonProperty('additionalFeeCash')
  public additionalFeeCash?: number;

  @JsonProperty('unit')
  public unit?: string;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty('gguid')
  public gguid?: string;

  @JsonProperty({clazz: Marketday, name: 'marketday'})
  public marketday?: Marketday;

  constructor() {
    this.id =  void 0;
    this.marketdayNumber =  void 0;
    this.validFrom =  void 0;
    this.validMonth =  void 0;
    this.priceType =  void 0;
    this.priceCategoryA =  void 0;
    this.priceCategoryB =  void 0;
    this.priceCategoryC =  void 0;
    this.priceCategoryD =  void 0;
    this.minBoothFee =  void 0;
    this.permanentMarketingFee = void 0;
    this.basicCharges =  void 0;
    this.additionalFeeCash = void 0;
    this.unit =  void 0;
    this.updated =  void 0;
    this.created =  void 0;
    this.gguid =  void 0;
    this.marketday =  void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/boothfee.model.ts